export enum FolderStructure {
	UnderDevelopment = 'Under Development',
	MegaMenu = 'Mega Menu'
}
